import clsx from "clsx";
import React from "react";
import './style.css';

export const BaseTextarea = ({onChange, value, isDisabled = false, isRequired = true, type = "text"}) => {
  return (
    <textarea
      className={clsx("textarea", {"textarea-disabled": isDisabled})}
      placeholder="請輸入"
      value={value}
      onChange={onChange}
      disabled={isDisabled}
      required={isRequired}
      rows={3}
    />)
}